module.exports = __webpack_public_path__ + "img/economy.4b40af12.png";